export default class User {
  constructor (uid, name, lastname, avatar) {
    this.uid = uid
    this.name = name
    this.lastname = lastname
    this.avatar = avatar
  }
}
